import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, Typography, Link } from '@material-ui/core';
import { useAuthorizeCheckboxStyles } from './styles';
import {
  termsAuthorization,
  privacyPolicies,
} from '../../../../../../../config/paths';

const AuthorizeCheckbox = ({ ...props }) => {
  const { disabled, onCheck, idComplement } = props;
  const classes = useAuthorizeCheckboxStyles();
  const [checked, setChecked] = useState(false);

  const handleCheck = () => {
    setChecked(!checked);
    onCheck(!checked);
  };

  return (
    <Box display="flex" alignItems="center" marginTop="26px" margin="26px auto">
      <Checkbox
        className={classes.checkbox}
        onChange={handleCheck}
        checked={checked}
        disabled={disabled}
        id={`authorizeCheckbox${idComplement}`}
      />
      <Typography className={classes.text}>
        Acepto los{' '}
        <Link href={termsAuthorization} target="_blank">
          Términos y Condiciones
        </Link>{' '}
        y las{' '}
        <Link href={privacyPolicies} target="_blank">
          Políticas de Privacidad
        </Link>
      </Typography>
    </Box>
  );
};

AuthorizeCheckbox.propTypes = {
  disabled: PropTypes.bool,
  onCheck: PropTypes.func,
  idComplement: PropTypes.string,
};

export default AuthorizeCheckbox;
